const $$splitComponentImporter = () => import('/src/src/routes/_authenticated/_feature_announcement/_user/profile.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from "@tanstack/react-router";
import { defineMessage } from "react-intl";

// User Profile Layout
export const Route = createFileRoute("/_authenticated/_feature_announcement/_user/profile")({
  component: lazyRouteComponent($$splitComponentImporter, 'component'),
  staticData: {
    pageTitle: defineMessage({
      defaultMessage: "Profile",
      description: "Page title"
    })
  }
});